import React, { useEffect } from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import OptionalSection from '@cotyorg/ccx-utils/js/components/OptionalSection';
import { HeroFullBlock } from '@cotyorg/ccx-organism-hero';
import StandardLayout from '../../templates/StandardLayout';
import PageDescription from '../../organisms/PageDescription';
import useScript from '../../utils/hooks/useScript';

const JoinComponent = ({
  sectionHeadings,
  klaviyoSourceUrl,
  klaviyoFormClassname,
}) => {
  useScript(klaviyoSourceUrl);

  useEffect(() => {
    if (!klaviyoSourceUrl) {
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const privacyLink = document.querySelector(
        '.klaviyo-form a[href*="terms"]'
      );

      if (privacyLink) {
        privacyLink.setAttribute('target', '_blank');
        privacyLink.setAttribute('rel', 'noopener noreferrer');
        obs.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [klaviyoSourceUrl]);

  return (
    <StandardLayout>
      <div className="join">
        <div className="main-hero-section">
          <div className="main-hero-heading">
            <OptionalSection
              renderCondition={
                !!R.path(['pageHeaderSection', 'heading'], sectionHeadings)
              }
              section={() => (
                <PageDescription
                  heading={R.path(
                    ['pageHeaderSection', 'heading'],
                    sectionHeadings
                  )}
                  text={R.path(
                    ['pageHeaderSection', 'introduction'],
                    sectionHeadings
                  )}
                />
              )}
            />
          </div>
          <div className="grid-container">
            <div className="grid-x">
              <div className="cell xsmall-16">
                <div className="join__hero-main">
                  <HeroFullBlock
                    layout="vertical"
                    heroStoreDataKey="hero"
                    isUnderlined={false}
                    headingLevel={1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-wrapper">
          <div className={klaviyoFormClassname} />
        </div>
      </div>
    </StandardLayout>
  );
};

JoinComponent.propTypes = {
  sectionHeadings: PropTypes.objectOf(PropTypes.object),
  klaviyoSourceUrl: PropTypes.string,
  klaviyoFormClassname: PropTypes.string,
};

export default connect(({ content }) => ({
  sectionHeadings: R.prop('sectionHeadings', content),
  klaviyoSourceUrl: R.prop('klaviyoSourceUrl', content),
  klaviyoFormClassname: R.prop('klaviyoFormClassname', content),
}))(JoinComponent);
